//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mdiCommentOutline } from '@mdi/js'

export default {
  setup() {
    return {
      icons: {
        mdiCommentOutline,
      },
    }
  },
}
